// extracted by mini-css-extract-plugin
export default {"frame":"frame-module--frame--y5n+n","cover":"frame-module--cover--4rlwE","frameMedia":"frame-module--frame-media--Vq1fM","contain":"frame-module--contain--7u5aV"};